import { useMutation } from "@tanstack/react-query";

import { getUsersByParameters, UserSearchParameters } from "#/api/user.api";
import { UserRow } from "#/api/user.type";

export type ExtendedUserSearchParameters = UserSearchParameters & {
  email_summary?: {
    patient_email?: string | null;
    patient_first_name?: string | null;
    patient_last_name?: string | null;
    patient_dob?: string | null;
  };
  metadata?: { patientId?: string | null; patient_id?: string | null };
  objectMetadata?: { patientId?: string | null; patient_id?: string | null };
};

export function useFindUsersByParameters() {
  return useMutation<UserRow[], Error, ExtendedUserSearchParameters>({
    mutationKey: ["users", "search-by-parameters"],
    mutationFn: getUsersByParameters,
  });
}

export default useFindUsersByParameters;
